export enum EnumLoginStatus {
  Unknown = 0,
  Success = 1,
  ChangePassword = 2,
  Locked = 3,
  SwitchToStoreInDB = 4, // Obsolete
  ConfirmUserInformation = 5,
  SsoDisabled = 6,
}

export enum EnumUserStatus {
  Unknown = 0,
  Enabled = 1,
  Disabled = 2,
  Deleted = 3,
  MissingEULAAccept = 1000, // Obsolete
  Expired = 1001,
  ExpiredTrial = 1002,
  UnauthorizedNetwork = 1003,
  MaxLoginsReached = 1004
}

export enum VerificationType {
  SMS = 0,
  EMAIL = 1,
  AUTHENTICATOR = 2
}

export interface TwoFactorOption {
  isVerified: boolean;
  checked: boolean;
  optionData: { display: string; };
  verificationType: VerificationType;
}

export interface UserBadLoginAttempt {
  badLoginAttemptCount: number;
  loginStatus: EnumLoginStatus | string;
  userStatus: EnumUserStatus | string;
  maxLoginsAllowed: number;
  ssoClientId?: number;
  directLoginBlocked: boolean;
}

export interface Globals extends Window {
  badLogInAttempt: UserBadLoginAttempt;
  twoFactorOptions: TwoFactorOption[];

  bootstrapLoginComponent: boolean;
  bootstrapSsoOptionsComponent: boolean;
  bootstrapSsoVerifyAccountComponent: boolean;
  bootstrapExternalLoginErrorComponent: boolean;
  bootstrapSsoMaxSessionsComponent: boolean;
  bootstrapResetPasswordComponent: boolean;
  bootstrapForgotPasswordComponent: boolean;
  bootstrapTwoFactorSelectionComponent: boolean;
  bootstrapLogoutComponent: boolean;
  bootstrapBeginEnrollmentComponent: boolean;
  bootstrapEnrollmentOptionsComponent: boolean;
  bootstrapTypeEnrollmentComponent: boolean;
  bootstrapVerificationCodeComponent: boolean;
  bootstrapAuthenticatorComponent: boolean;
  bootstrapCompleteEnrollmentComponent: boolean;
  bootstrapSsoButtonComponent: boolean;
}

export const globals: Globals = (window as Window) as Globals;
